import { useQuery } from "@tanstack/react-query";

import { getProfile } from "../../core/profile.core";
import { useTranslation } from "../../core/translation.core";
import { profileGridCss } from "../reuseables/native.comp";

export default function ProfileMe() {
  const { t, msg } = useTranslation();

  const { data: profile } = useQuery({
    queryKey: ["me"],
    queryFn: getProfile,
    refetchInterval: 1000 * 60 * 10, // 10 minutes
  });

  if (!profile) return null;

  return (
    <>
      <div className={profileGridCss}>
        <span>{t(msg.setting.email)}</span>
        <span id="span-email">{profile.email}</span>
      </div>

      <div className={profileGridCss}>
        <span>{t(msg.setting.userRole)}</span>
        <span>{profile.type}</span>
      </div>
    </>
  );
}
